import {getLocale, translate} from './TranslationsContext';

// The API refuses this organization from the network the browser is on (the network_restricted
// hold, api/common/account_policy.py). Nothing in the app can clear it — the organization decides
// — but a VPN switched on or off can, so trying again sits alongside the other ways out.
//
// Rendered by AuthProvider, outside TranslationsProvider, so it reads the locale itself.
export default function NetworkRestricted({
  onSwitchOrganization,
  onSignOut,
}: {
  // Offered only when the user can reach another organization.
  onSwitchOrganization?: () => void;
  onSignOut: () => void;
}) {
  const locale = getLocale(null);
  const buttonClassName = 'text-blue-700 underline hover:text-blue-900';
  return (
    <div className="min-h-screen flex justify-center items-center px-4">
      <div className="max-w-xl text-center space-y-4">
        <h1 className="text-2xl font-semibold text-gray-900">
          {translate(locale, 'networkRestrictedTitle')}
        </h1>
        <p className="text-gray-700">{translate(locale, 'networkRestrictedMessage')}</p>
        <div className="flex flex-wrap justify-center gap-6">
          <button
            type="button"
            className={buttonClassName}
            onClick={() => window.location.reload()}
          >
            {translate(locale, 'networkRestrictedTryAgain')}
          </button>
          {onSwitchOrganization && (
            <button type="button" className={buttonClassName} onClick={onSwitchOrganization}>
              {translate(locale, 'networkRestrictedSwitchOrganization')}
            </button>
          )}
          <button type="button" className={buttonClassName} onClick={onSignOut}>
            {translate(locale, 'networkRestrictedSignOut')}
          </button>
        </div>
      </div>
    </div>
  );
}
